import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { auditApi, type AuditEventType } from '../api/auditApi';
import { auditKeys, type AuditEventsQuery } from '../queryKeys';

export function useAuditEvents(query: AuditEventsQuery) {
  return useQuery({
    queryKey: auditKeys.events(query),
    queryFn: () =>
      auditApi.listEvents({
        search: query.search || undefined,
        eventType: query.eventType === 'all' ? undefined : (query.eventType as AuditEventType),
        days: query.days,
        page: query.page,
        limit: 50,
      }),
    // Hold the previous page on screen while the next one loads, so typing in
    // the search box does not flash an empty table on every keystroke.
    placeholderData: keepPreviousData,
  });
}

export function useAuditSummary() {
  return useQuery({
    queryKey: auditKeys.summary(),
    queryFn: () => auditApi.getSummary(),
  });
}

export function useAuditSession(sessionId: string | null) {
  return useQuery({
    queryKey: auditKeys.session(sessionId ?? ''),
    queryFn: () => auditApi.getSession(sessionId!),
    enabled: !!sessionId,
  });
}
